import { render, staticRenderFns } from "./AxShortcutPublicLink.vue?vue&type=template&id=00776d42&scoped=true&"
import script from "./AxShortcutPublicLink.vue?vue&type=script&lang=ts&"
export * from "./AxShortcutPublicLink.vue?vue&type=script&lang=ts&"
import style0 from "./AxShortcutPublicLink.vue?vue&type=style&index=0&id=00776d42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00776d42",
  null
  
)

export default component.exports